import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportVesEvents } from '@api/vesEvents';

import { IVesEventsExportDTO } from '@interfaces/vesData/dto/vesEventsDTO';

import { ESnackbarTypes } from '@enums/common';

import { VES_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateVesEventsExport = () => {
	const dispatch = useAppDispatch();

	const { mutate, isLoading } = useMutation<IVesEventsExportDTO>({
		mutationKey: [VES_EXPORT],
		mutationFn: exportVesEvents,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportVesEvents: mutate,
		isExportingVesEvents: isLoading,
	};
};
